import { EventTypeEnum } from '../models/enums/eventType.enum';

export const getEventType = (publicSignUp: boolean, membersOnly: boolean): EventTypeEnum => {
  if (publicSignUp && !membersOnly) {
    return EventTypeEnum.Public;
  }
  if (!publicSignUp && !membersOnly) {
    return EventTypeEnum.NonPublic;
  }
  if (!publicSignUp && membersOnly) {
    return EventTypeEnum.OnlyMembers;
  }

  return EventTypeEnum.NonPublic;
};
